// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  visibleMessengerId: __t.string().name("visible_messenger_id"),
  playerId: __t.string().name("player_id"),
  matchId: __t.string().name("match_id"),
  messengerId: __t.string().name("messenger_id"),
  x: __t.f64(),
  y: __t.f64(),
  targetUnitId: __t.string().name("target_unit_id"),
  orderType: __t.string().name("order_type"),
});
